import { useAmountWithConversion } from '#src/hooks/useAmountWithConversion.ts';

export const Amount = (
  props: Parameters<typeof useAmountWithConversion>[0]
) => {
  const { main } = useAmountWithConversion(props);
  return main;
};
